//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import alternateEnglish from './photo-editor-alternate-english';
import sdkLicenseData from './photo-editor-license';

export default {
  title: 'Beautify',
  license: JSON.stringify(sdkLicenseData),
  assets: {
    baseUrl: `${CURALATE_ENV.PUBLIC_PATH}photoeditorsdk/assets`,
    resolver: (path: string) => {
      // v. 4.16 looks for some files in jpg format, we need to tell it to search for png, instead
      const filenames = [
        'all@2x',
        'imgly_filters_duotone@2x',
        'imgly_filters_bw@2x',
        'imgly_filters_retro@2x',
        'imgly_filters_analog@2x',
        'imgly_filters_winter@2x',
        'imgly_filters_summer@2x',
        'imgly_filters_legacy@2x',
      ].map((fname) => `(${fname})`);
      const regexp = new RegExp(`/(${filenames.join('|')}).jpg`);
      if (regexp.exec(path)) {
        return path.replace(/\.jpg$/, '.png');
      }
      return path;
    },
  },
  style: {
    width: 800,
    height: 800,
  },
  extensions: {
    languages: {
      altEnglish: alternateEnglish,
    },
  },
  // Set alternate language file so we can replace the text of the Export button with Save.
  language: 'altEnglish',
  responsive: true,
  showCloseButton: true,
  // Disabling both webcam and uploads hides the New button.
  enableWebcam: false,
  enableUpload: false,
  editor: {
    export: {
      format: 'image/jpeg',
      type: 'data-url',
      quality: 0.95,
      download: false,
    },
    enableZoom: false,
    enableExport: true,
    controlsOptions: {
      transform: {
        availableRatios: [
          'imgly_transform_common_custom',
          'imgly_transform_common_square',
          'imgly_transform_common_4-5',
          'imgly_transform_common_9-16',
          'imgly_transform_common_16-9',
          'imgly_transform_common_4-3',
          'imgly_transform_common_5-4',
        ],
        ratios: [
          {
            identifier: 'imgly_transform_common_4-5', // A unique identifier for this ratio
            defaultName: '4:5 Portrait', // The default translation for this ratio
            ratio: 4 / 5, // The image ratio (a floating point number)
          },
          {
            identifier: 'imgly_transform_common_5-4',
            defaultName: '5:4',
            ratio: 5 / 4,
          },
          {
            identifier: 'imgly_transform_common_9-16',
            defaultName: '9:16 IG Story',
            ratio: 9 / 16,
          },
        ],
      },
    },
    tools: ['transform', 'rotation', 'flip', 'filter', 'brightness', 'saturation', 'gamma', 'contrast', 'clarity',
      'exposure', 'shadows', 'highlights', 'text', 'sticker', 'brush', 'radial-focus',
      'mirrored-focus', 'frame'],
  },
};
